export default __webpack_public_path__ + "media/search/go-arrow-73160f92.svg";